import React, {useState, useEffect} from 'react';


import './search.css';


const Search = ({search, onSearch}) => {  
  
  
    const [searchTerm, setSearchTerm] = useState('')

    useEffect(() => {          
     if(search){
      setSearchTerm(search)  
     }
     
    }, []);



    const onChangeSearch = (e) => {                  
        setSearchTerm(e.target.value) 
    }

    const onClickSubmit  = () => {
        onSearch(searchTerm)
    }

    console.log('search', searchTerm)
  return (
    
    <div className="search-container">
        <input 
            className="search-container-field"
            type="text"
            value={searchTerm} 
            onChange={onChangeSearch}
            />
            <button type="button" onClick={onClickSubmit }> <i className=" icofont-search-2"></i></button>
    </div>
    
    // onChange={(e) => onSearch(e.target.value) }
 
   
  ); 
};

export default Search;